module.exports = __webpack_public_path__ + "static/img/author.3743bf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/author.png
// module id = UQC4
// module chunks = 1